import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { reduxForm } from 'redux-form';
import { injectIntl } from 'react-intl';

// Components
import RemindersAndUpdates from './RemindersAndUpdates';

// Actions
import {
  setPrivacySettings,
  setMobilePhoneNumber,
  setObfuscatedBy
} from 'store/reducers/appointment/actions';
import {
  mobilePhoneNumberNotPopulated,
  mobilePhoneNumberModified
} from 'store/reducers/userInteractions/actions';
import { resetObfuscatedContactInfo } from 'store/reducers/appointment/contactInfo/actions';

// Selectors
import { getTranslate } from 'store/reducers/localizationString/selectors';
import {
  getPhoneNumber,
  showPhoneNumber
} from 'store/reducers/user/personInfo/selectors';
import {
  getIsObfuscated,
  getObfuscatedBy
} from 'store/reducers/appointment/contactInfo/selectors';
import { getDealerCountryCode } from 'store/reducers/dealerSettings/selectors';
import {
  isPopulateMobilePhoneNumber,
  getAppFlow,
  isModifyEnabledFindMe,
  getSavedMobile
} from 'store/reducers/userInteractions/selectors';
import {
  getContactInfo,
  getPrivacySettings,
  getAttendanceStatus,
  isDmsAppt
} from 'store/reducers/appointment/selectors';

function validate(values) {
  const errors = {};
  if (!values) {
    errors['mobilePhone'] = 'Required field';
  }

  return errors;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setPrivacySettings,
      setMobilePhoneNumber,
      mobilePhoneNumberNotPopulated,
      mobilePhoneNumberModified,
      setObfuscatedBy,
      resetObfuscatedContactInfo
    },
    dispatch
  );
}

const mapStateToProps = state => {
  const contactInfo = getContactInfo(state);
  return {
    contactInfo,
    initialValues: contactInfo,
    getTranslate: getTranslate(state),
    getPhoneNumber: getPhoneNumber(state),
    dealerCountryCode: getDealerCountryCode(state),
    isPopulateMobilePhoneNumber: isPopulateMobilePhoneNumber(state),
    showPhoneNumber: showPhoneNumber(state),
    privacySettings: getPrivacySettings(state),
    isObfuscated: getIsObfuscated(state),
    obfuscatedBy: getObfuscatedBy(state),
    isDmsAppt: isDmsAppt(state),
    appFlow: getAppFlow(state),
    isModifyEnabledFindMe: isModifyEnabledFindMe(state),
    appointmentStatus: getAttendanceStatus(state),
    savedMobileNumber: getSavedMobile(state)
  };
};

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(
  reduxForm({
    validate,
    form: 'RemindersForm',
    enableReinitialize: true
  })(RemindersAndUpdates)
);



// WEBPACK FOOTER //
// ./src/components/molecules/RemindersAndUpdates/RemindersAndUpdatesContainer.js